import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Login from "./pages/Login";
import SuperAdminDashboard from "./pages/dashboards/SuperAdminDashboard";
import AdminDashboard from "./pages/dashboards/AdminDashboard";
import ReceptionnisteDashboard from "./pages/dashboards/ReceptionnisteDashboard";
import ProtocoleDashboard from "./pages/dashboards/ProtocolDashboard";
import MegaAdminDashboard from "./pages/dashboards/MegaAdminDashboard";
import OrganizerDashboard from "./pages/organizer/OrganizerDashboard";
import { PrivateRoute, RoleRoute } from "./routes/Guards";
import InvitationPage from "./pages/InvitationPage";
import ScanPage from "./pages/scan/ScanPage";
import EvenementInvitation from "./templates/events/EvenementInvitation";
import AnniversaireInvitation from "./templates/anniv/AnniversaireInvitation";
import EvenementList from "./components/EvenementList";
import EvenementForm from "./components/EvenementForm";
import AnniversaireList from "./components/AnniversaireList";
import AnniversaireForm from "./components/AnniversaireForm";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />

          <Route
            path="/dashboard/mega"
            element={
              <PrivateRoute>
                <RoleRoute allow={["megaadmin"]}>
                  <MegaAdminDashboard />
                </RoleRoute>
              </PrivateRoute>
            }
          />

          <Route
            path="/dashboard/super"
            element={
              <PrivateRoute>
                <RoleRoute allow={["super_admin", "megaadmin"]}>
                  <SuperAdminDashboard />
                </RoleRoute>
              </PrivateRoute>
            }
          />
          
          <Route
            path="/dashboard/admin"
            element={
              <PrivateRoute>
                <RoleRoute allow={["admin", "super_admin", "megaadmin"]}>
                  <AdminDashboard />
                </RoleRoute>
              </PrivateRoute>
            }
          />

          <Route
            path="/dashboard/organizer"
            element={
              <PrivateRoute>
                <RoleRoute allow={["organisateur", "admin", "super_admin", "megaadmin"]}>
                  <OrganizerDashboard />
                </RoleRoute>
              </PrivateRoute>
            }
          />
          
          <Route
            path="/dashboard/receptionniste"
            element={
              <PrivateRoute>
                <RoleRoute allow={["receptionniste", "admin", "super_admin", "megaadmin"]}>
                  <ReceptionnisteDashboard />
                </RoleRoute>
              </PrivateRoute>
            }
          />

          <Route path="/scan/:mariageId" element={<ScanPage />} />
          
          <Route
            path="/dashboard/protocole"
            element={
              <PrivateRoute>
                <RoleRoute allow={["protocole", "admin", "super_admin", "megaadmin"]}>
                  <ProtocoleDashboard />
                </RoleRoute>
              </PrivateRoute>
            }
          />

          {/* Routes pour les invitations */}
          <Route path="/invitation/:token" element={<InvitationPage />} />
          <Route path="/evenement/:token" element={<EvenementInvitation />} />
          <Route path="/anniversaire/:token" element={<AnniversaireInvitation />} />
          
          {/* Routes pour la gestion des événements */}
          <Route
            path="/evenements"
            element={
              <PrivateRoute>
                <RoleRoute allow={["admin", "super_admin", "megaadmin"]}>
                  <EvenementList />
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/evenements/creer"
            element={
              <PrivateRoute>
                <RoleRoute allow={["admin", "super_admin", "megaadmin"]}>
                  <EvenementForm />
                </RoleRoute>
              </PrivateRoute>
            }
          />
          
          {/* Routes pour la gestion des anniversaires */}
          <Route
            path="/anniversaires"
            element={
              <PrivateRoute>
                <RoleRoute allow={["admin", "super_admin", "megaadmin"]}>
                  <AnniversaireList />
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/anniversaires/creer"
            element={
              <PrivateRoute>
                <RoleRoute allow={["admin", "super_admin", "megaadmin"]}>
                  <AnniversaireForm />
                </RoleRoute>
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;